
import {toRefs, reactive, defineComponent, PropType} from 'vue'
import DealDTO from "@/models/DealDTO";
import {paymentMethodsHelper} from "@/service/PaymentMethodsHelper"
import {numberFormatter} from "@/service/NumberFormatter"
import InvoiceStateDTO from "@/models/InvoiceStateDTO";
const apiUrl = window.API_URL;

export default defineComponent({
  props: {
    deal: {
      type: Object as PropType<DealDTO>,
      default: false
    },
    invoice: {
      type: Object as PropType<InvoiceStateDTO>,
      default: false
    }
  },
  setup(props) {

    const state = reactive({
      copyHintTimeout: {'amount': null, 'req': null} as any,
    });

    return {
      ...toRefs(state),
      paymentMethodsHelper,
      numberFormatter,
      apiUrl
    }
  }
})
